import React from "react";
import { useNavigate } from "react-router-dom";
import { CButton, CContainer } from "@coreui/react-pro";
import PublicContentPageShell from "../../components/public/PublicContentPageShell";
import "../../styles/public-experience.css";
import "../../styles/public-family-alignment.css";

const sections = [
  {
    title: "1. Angaben zum Diensteanbieter",
    content: (
      <>
        <address className="public-legal-address">
          <strong>Experts4Europe GmbH in Gründung</strong>
          <span>Kirchgasse 37</span>
          <span>9853 Gmünd in Kärnten</span>
          <span>Österreich</span>
        </address>
        <p>Vertretungsberechtigt: Markus Diehl, geschäftsführender Gesellschafter</p>
        <p>
          E-Mail: <a href="mailto:Info@Experts4Europe.com">Info@Experts4Europe.com</a>
        </p>
      </>
    ),
  },
  {
    title: "2. Unternehmensgegenstand",
    content: (
      <p>
        Experts4Europe betreibt digitale Angebote zur strukturierten internationalen Rekrutierung,
        Vorqualifizierung, Bewerbungs- und Dokumentenvorbereitung sowie zur Zusammenarbeit zwischen
        Fachkräften, Arbeitgebern und internen Bearbeitungsstellen.
      </p>
    ),
  },
  {
    title: "3. Kontakt",
    content: (
      <p>
        Allgemeine Anfragen, Support- und Rechtsanliegen können an{" "}
        <a href="mailto:Info@Experts4Europe.com">Info@Experts4Europe.com</a> gerichtet werden.
      </p>
    ),
  },
  {
    title: "4. Hinweis zum Gesellschaftsstatus",
    content: (
      <p>
        Die Gesellschaft wird derzeit als <strong>GmbH in Gründung</strong> geführt. Weitere
        formale Register- und Unternehmensangaben werden nachgereicht, sobald sie vorliegen.
      </p>
    ),
  },
  {
    title: "5. Haftung für Inhalte",
    content: (
      <p>
        Wir erstellen die Inhalte dieser Website mit großer Sorgfalt. Gleichwohl übernehmen wir
        keine Gewähr für Richtigkeit, Vollständigkeit und Aktualität aller bereitgestellten
        Inhalte, soweit gesetzlich zulässig.
      </p>
    ),
  },
  {
    title: "6. Haftung für Links",
    content: (
      <p>
        Unsere Angebote können Links zu externen Websites Dritter enthalten. Auf deren Inhalte
        haben wir keinen laufenden Einfluss. Für die Inhalte verlinkter Seiten sind stets die
        jeweiligen Anbieter oder Betreiber verantwortlich.
      </p>
    ),
  },
  {
    title: "7. Urheberrecht",
    content: (
      <p>
        Inhalte, Texte, Grafiken, Layouts, Bilder und sonstige Werke auf dieser Website unterliegen
        dem jeweils anwendbaren Urheber- und Leistungsschutzrecht. Eine Nutzung außerhalb der
        gesetzlichen Schranken bedarf der vorherigen Zustimmung des jeweiligen Rechteinhabers.
      </p>
    ),
  },
  {
    title: "8. Datenschutz",
    content: (
      <p>
        Informationen zur Verarbeitung personenbezogener Daten finden Sie in unserer{" "}
        <a href="/datenschutz">Datenschutzerklärung</a>.
      </p>
    ),
  },
];

export default function Impressum() {
  const navigate = useNavigate();

  const hero = (
    <section className="public-legal-hero">
      <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
        <div className="public-legal-hero__panel public-page-hero-panel">
          <div className="public-legal-hero__copy">
            <span className="public-core-eyebrow public-page-overline">Impressum</span>
            <h1 className="public-page-title">Rechtliche Anbieterangaben</h1>
            <p className="public-legal-hero__lead public-page-body">
              Dieses Impressum gilt für die öffentliche Website von Experts4Europe sowie für
              die damit verbundenen digitalen Angebote, soweit dort keine spezielleren
              Anbieterhinweise veröffentlicht sind.
            </p>
            <div className="public-legal-chip-row">
              <span>Experts4Europe</span>
              <span>Website</span>
              <span>Applicant</span>
              <span>Employer</span>
            </div>
          </div>

          <aside className="public-legal-hero__meta">
            <div className="public-legal-callout public-page-callout">
              <strong>Diensteanbieter</strong>
              <span>Experts4Europe GmbH in Gründung</span>
            </div>
            <div className="public-legal-callout public-page-callout">
              <strong>Sitz</strong>
              <span>Kirchgasse 37, 9853 Gmünd in Kärnten, Österreich</span>
            </div>
            <div className="public-legal-callout public-page-callout">
              <strong>Vertretungsberechtigt</strong>
              <span>Markus Diehl, geschäftsführender Gesellschafter</span>
            </div>
          </aside>
        </div>
      </CContainer>
    </section>
  );

  return (
    <PublicContentPageShell pageClassName="public-legal-page" hero={hero}>
      <section className="public-core-band public-core-band--neutral">
        <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
          <div className="public-legal-card public-page-card">
            <span className="public-core-eyebrow public-page-overline">Schnellüberblick</span>
            <div className="public-legal-basis-grid public-legal-basis-grid--compact">
              <article className="public-legal-basis-card public-page-value-card">
                <h3>Anbieter</h3>
                <p>Experts4Europe GmbH in Gründung, Kirchgasse 37, 9853 Gmünd in Kärnten, Österreich.</p>
              </article>
              <article className="public-legal-basis-card public-page-value-card">
                <h3>Kontakt</h3>
                <p>
                  Allgemeine, rechtliche und organisatorische Anfragen laufen über{" "}
                  <a href="mailto:Info@Experts4Europe.com">Info@Experts4Europe.com</a>.
                </p>
              </article>
              <article className="public-legal-basis-card public-page-value-card">
                <h3>Status</h3>
                <p>Register- und Zusatzangaben werden ergänzt, sobald die formalen Schritte abgeschlossen sind.</p>
              </article>
            </div>
          </div>
        </CContainer>
      </section>

      <section className="public-core-band public-core-band--light">
        <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
          <div className="public-legal-stack">
            {sections.map((section) => (
              <article key={section.title} className="public-legal-card public-page-card">
                <h2>{section.title}</h2>
                <div className="public-legal-richtext public-page-richtext">{section.content}</div>
              </article>
            ))}
          </div>

          <div className="public-legal-nav public-page-card">
            <div className="public-legal-nav__copy">
              <span className="public-core-eyebrow public-page-overline">Rechtliche Seiten</span>
              <h2 className="public-page-subtitle">Weitere öffentliche Pflichtinformationen</h2>
              <p className="public-page-body public-page-body--muted">
                Die Legal-Seiten wurden auf denselben Public-Standard wie Startseite und Leitbild
                gezogen und bleiben direkt untereinander erreichbar.
              </p>
            </div>
            <div className="public-legal-nav__actions">
              <CButton type="button" className="public-core-btn public-core-btn--subtle" onClick={() => navigate("/agb")}>
                AGB
              </CButton>
              <CButton type="button" className="public-core-btn public-core-btn--ghost" onClick={() => navigate("/datenschutz")}>
                Datenschutz
              </CButton>
            </div>
          </div>
        </CContainer>
      </section>
    </PublicContentPageShell>
  );
}
